import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Media from 'components/common/MediasModal/Media';
import { getApiErrorByMode, hasMoreByMode, isLoadingByMode } from 'modules/mediaLibrary/selector';

import { InfiniteScroll } from 'ui/base';
import Alert from 'ui/base/Alert';

import { Content } from './UI';

/**
 * @typedef {{
 *   onMediaClick : (mediaId: string) => void
 * }} LibraryProps
 */

/** @type {React.FC<LibraryProps>} */
const Library = ({
  mode,
  medias,
  shortCard,
  className,
  scrollProps,
  onMediaClick,
  fetchNextPage,
  selectedMedias,
  disabledAddMedia,
  showCheckBox: showCheckBoxProps,
}) => {
  const hasMore = useSelector(state => hasMoreByMode(state, mode));
  const apiError = useSelector(state => getApiErrorByMode(state, mode));
  const isFetching = useSelector(state => isLoadingByMode(state, mode));

  const shouldShowMedias = medias?.length > 0;
  const shouldShowNoData = !isFetching && !apiError && !shouldShowMedias;

  return (
    <InfiniteScroll
      hasMore={hasMore}
      apiError={apiError}
      isFetching={isFetching}
      loadMore={fetchNextPage}
      {...scrollProps}
    >
      {shouldShowMedias && (
        <Content shortCard={shortCard} className={className}>
          {medias?.map(singleMedia => {
            const selected = selectedMedias?.some(media => media.id === singleMedia.id);
            const disabled = disabledAddMedia && !selected;
            const showCheckBox = showCheckBoxProps && !disabled;

            return (
              <Media
                key={singleMedia.id}
                name={singleMedia.name}
                onClick={onMediaClick}
                favorite={singleMedia.favorite}
                {...singleMedia.media}
                id={singleMedia.id}
                selected={selected}
                showCheckBox={showCheckBox}
                className={classnames('media', { 'media-active': selected })}
              />
            );
          })}
        </Content>
      )}
      {shouldShowNoData && (
        <Alert
          type="info"
          title={<FormattedMessage id="info.label" defaultMessage="Information" />}
          description={<FormattedMessage id="info.empty_records" defaultMessage="No records available." />}
        />
      )}
    </InfiniteScroll>
  );
};

export default Library;
